import { useQuery } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrors } from 'utils/handle-errors'
import { organizationsKeys } from 'utils/query-keys'

interface AssociatedOrganizationSubscription {
  subscription_id: string
  status: string
  seat_count: number
  stripe_customer_id: string
}

interface AssociatedOrganization {
  id: number
  name: string
  created_at: string
  subscriptions: AssociatedOrganizationSubscription[]
}

interface AssociatedOrganizationsResponse {
  organizations: AssociatedOrganization[]
}

const fetchAssociatedOrganizations = async (
  orgId: string
): Promise<AssociatedOrganizationsResponse> => {
  let response = await fetch(
    `${BASE_API_URL}/admin/api/v2/organizations/${orgId}/associated_organizations`,
    {
      method: API_METHODS.GET,
      headers: apiHeaders(store.getState()),
    }
  )
  response = handleErrors(response)
  return response.json()
}

const useOrganizationAssociatedOrganizations = (orgId: string) => {
  return useQuery(
    [...organizationsKeys.all, orgId, 'associated'],
    () => fetchAssociatedOrganizations(orgId),
    {
      enabled: !!orgId,
    }
  )
}

export default useOrganizationAssociatedOrganizations
export type { AssociatedOrganization, AssociatedOrganizationSubscription }
